import { createRouter, createWebHistory } from 'vue-router'

export const appRouter = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            redirect: '/image-editor'
        },
        {
            path: '/image-editor',
            name: 'image-editor',
            component: () => import('../app/page/sw-image-editor.vue')
        }
    ]
})

export const locationRouter = createRouter({
    history: createWebHistory(),
    routes: []
})
